import "./Side-drawer.css";

export default function SideDrawer({
  isOpen,
  cancelBbutton,
  submitButton,
  cancelButtonLabel,
  submitButtonLabel,
  direction,
  children,
  onOverlayClick
}) {

  return (
    <div
      className={`${isOpen ? "side-drawer-overlay" : ""}`}
      onClick={onOverlayClick}
    >
      <div
        className={` side-drawer-${direction} ${
          isOpen ? "side-drawer-expanded" : ""
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="side-drawer-content">{children}</div>
        <div className="side-drawer-actions p-2  text-end d-flex">
          <button className="btn btn-second  m-2" onClick={cancelBbutton}>
            {cancelButtonLabel}
          </button>
          <button className="btn  btn-second m-2" onClick={submitButton}>
            {submitButtonLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
